const translation = {
    confirm: 'Sind Sie sicher?',
    common: { back: 'Zurück' },
    save: 'Speichern',
    returnToGame: 'Sind Sie sicher, dass Sie wieder ins Spiel einsteigen möchten?',
    yes: 'Ja',
    no: 'NEIN',
    login: {
        auth: 'Genehmigung',
        noAcc: 'Kein Account',
        reg: 'Registrieren',
        mail: 'Melden Sie sich per E-Mail an',
        registration: 'Anmeldung',
        agreement: 'Indem Sie auf die Schaltfläche „Registrieren“ klicken, bestätigen Sie Ihre',
        agreementLink: 'Zustimmung zur Verarbeitung personenbezogener Daten.',
        submit: 'Registrieren',
        continue: 'Weiter',
        emailLabel: 'Email',
        passwordLabel: 'Passwort',
        repeatPasswordLabel: 'Passwort wiederholen',
        loginButton: 'Anmeldung',
        logout: 'Ausloggen',
        invalidEmail: 'ungültiges Email-Format',
        invalidFormatPassword: 'Falsches Passwortformat',
        forgotPassword: 'Haben Sie Ihr Passwort vergessen',
        passwordRecovery: 'Passwort-Wiederherstellung',
        passwordRecoveryTitle: 'Wir senden einen Brief an die angegebene E-Mail',
        sendLetter: 'Brief schicken',
        userExists: 'Es existiert ein Benutzer mit dieser E-Mail',
        userNotExists: 'Der Benutzer mit dieser E-Mail existiert nicht',
        passwordResetToMail: 'Anweisungen zum Zurücksetzen Ihres Passworts wurden per E-Mail gesendet.',
        passwordValidation: 'Muss 8 bis 20 lateinische Buchstaben oder Zahlen enthalten',
        invalidPassword: 'Falsches Passwort',
        sessionNotFound: 'Sitzung nicht gefunden',
        mismatchPassword: 'Die Passwörter stimmen nicht überein! Versuchen Sie es erneut',
        rememberPassword: 'Ich habe mich an Ihr Passwort erinnert',
        restore: 'Wiederherstellen',
        accExist: 'Ein Konto haben',
        confirmationCode: 'Geben Sie den per E-Mail gesendeten Bestätigungscode ein',
        code: 'Bestätigungscode',
        send: 'Schicken',
        confirmation: 'Bestätigen',
        resend: 'Erneut senden',
        codeIsValid: 'Code ist gültig',
        codeNotValid: 'Code ist ungültig',
        newPassword: 'Geben Sie ein neues Kennwort ein',
        passwordUsedBefore: 'Das Passwort wurde bereits zuvor verwendet',
        passwordUpdatedSuccessfully: 'Passwort erfolgreich aktualisiert',
        enterEmail: 'Geben sie ihre E-Mailadresse ein',
        enterPassword: 'Passwort eingeben',
        enterPasswordAgain: 'Geben Sie Ihr Passwort erneut ein',
        enterAgreement: 'Bestätigen Sie Ihre Einwilligung zur Verarbeitung personenbezogener Daten',
        notRobot: 'Beweisen Sie, dass Sie kein Roboter sind',
        deletionPersonalData: 'Um personenbezogene Daten zu löschen, senden Sie uns eine Nachricht an unsere E-Mail-Adresse.',
    },
    profile: {
        edit: 'Profil bearbeiten',
        remove: 'Konto löschen',
        projectName: 'Projektname',
        editing: 'Bearbeiten Ihres Profils',
        name: 'Ihr Name',
        lastName: 'Ihr Nachname',
        inputPattern: 'Von zwei bis zehn Buchstaben',
        purchases: 'Käufe sind nicht vorhanden',
        settings: 'Einstellungen',
        transactions: 'Transaktionen',
        support: 'Unterstützung',
    },
    payment: {
        toPay: 'bezahlen',
        method: 'Bezahlverfahren',
        pay: 'Zahlen',
        purchases: 'Einkäufe',
        paymentMethod: 'Bezahlverfahren',
        debitCard: 'Debitkarte',
        copy: 'Zahlungs-ID kopiert!',
        cancellation: 'Möchten Sie die Zahlung wirklich stornieren?',
        email: 'E-Mail zum Erhalt einer Quittung',
        status: {
            none: 'Keiner',
            pending: 'Ausstehend',
            paid: 'Bezahlt',
            fail: 'Fehlgeschlagen',
        },
        state: {
            progress: 'Zahlung wird verarbeitet',
            wait: 'Bitte warten',
            paid: 'Bezahlt',
            successful: 'Zahlung war erfolgreich',
            notPaid: 'Nicht bezahlt',
            error: 'Fehler',
            cancelled: 'Zahlung storniert',
            cancel: 'Abbrechen',
        },
    },
    games: {
        header: {
            buttonGuest: 'Gast',
            buttonLogin: 'Anmelden',
            buttonLogout: 'Abmelden',
        },
        buttonPlay: 'Spielen',
        buttonInDevelop: 'In Entwicklung',
    },
    support: {
        noPurchases: 'Sie haben noch keine Einkäufe',
        contactSupport: 'Support kontaktieren',
        paymentId: 'Zahlungs-ID',
        userId: 'Benutzer-ID',
        requestReason: 'Grund der Anfrage',
        feedbackEmail: 'E-Mail für Rückmeldung',
        dropNotCredited: 'Drop nicht gutgeschrieben',
        other: 'Andere',
        success: 'Anfrage angenommen',
        successText: 'Wir haben Ihre Anfrage erhalten und werden Sie in Kürze per E-Mail kontaktieren',
        createTicket: 'Anfrage erstellen',
        ticketTitle: 'Meine Tickets',
        requestDescription: 'Bitte beschreiben Sie Ihr Problem möglichst detailliert',
        requestTitleDescription: 'Geben Sie einen Titel ein',
        ticketTitlePlug: 'Anfrage von',
        errorMessageFormat: 'Nicht unterstütztes Videoformat',
        errorMessageSize: 'Die Dateigröße überschreitet das Limit von',
        you: 'Sie',
        subject: 'Betreff der Anfrage',
        description: 'Beschreibung',
        descriptionEmptyWarning: 'Bitte beschreiben Sie das Problem',
        conversationEnded: 'Konversation beendet',
        system: 'Systemnachricht',
        messageDelivered: 'Nachricht vom System empfangen',
    },
    receipt: {
        generation: 'Beleg wird erstellt',
        wait: 'Dies kann einige Zeit dauern, bitte warten Sie.'
    },
    blocked: {
        title: 'Zugriff eingeschränkt',
        ip: 'Der Zugriff auf die Website ist für Benutzer aus Ihrer Region eingeschränkt. Wir entschuldigen uns für die Unannehmlichkeiten und danken Ihnen für Ihr Verständnis.'
    },
}

export default {
    translation,
}
